import { GET, POST } from '../request'
export default {
  /**
   * 获取所有枚举值
   */
  getAllEnum: (data) => {
    return GET('/front/enum/getAllEnum', data)
  },
  /**
   * 获取banner背景图
   */
  getBannerPage: (data) => {
    return POST('/front/banner/getBannerPage', data)
  },
  /**
   * 获取参数设置
   */
  getParameter: (data) => {
    return GET('/front/parameter/getParameter', data)
  },
  /**
   * 猪小智监管平台获取
   */
  getZhuXiaoZhi: (data) => {
    return GET('/front/zhuxiaozhi/getZhuXiaoZhi', data)
  }
}
